export class Lang{
	ref: string;
	name: string;

	static getLangs(){
		return ['fr', 'en', 'de', 'es', 'pt'];
	}
}

export class Variante{
	ref: string;
	name: string;
}
export class RemoteSet{
	id: string;
	name: string;
	nbCards: number;
	symbol: string;
	logo: string;
	lastUpdate: Date;
}

export class Rarity{
	ref: string;
	name: string;
	index: number;
}

export class CardSet{
	ident: string;
	type: string;
	name: string;
	symbol?: string;
	logo?: string;
	abbreviation: string;
	releaseDate: Date;
	nbCard?: number;
	nbOfficialCard?: number;
	lastUpdate: Date;
	translations: Translation[]=[];
}

export class Translation{
	cardSet: string;
	name: string;
	text: string;
	lang: string;
}

export class RemoteCard{
	id: string;
	image?: string;
	localId?: string;
	name: string;
	stateImport?: 'Importée' | 'Erreur'=null;
}

export class Card{
	ident: string;
	type: string='pkm';
	name: string;
	nameFeat: Feature[]=null;
	numero: string;
	rarity: string;
	img?: string=null;
	cardSet: string;
	categ: string;
	lastUpdate: Date;
	features: Feature[]=[];
	thirdParties: ThirdParty[]=[];

	initNames(){
		Lang.getLangs().forEach(lang => this.features.push({lang, name: 'name', text: 'Carte inconnue.'}));
	}
}

export class CardPrice{
	ident: string;
	card: string;
	marketplace: string;
	lang: string;
	condition: string;
	amount: string;
	lastUpdate: string;
	run: string;
}

export class Feature{
	ident?: string=null;
	card?: string=null;
	lang: string;
	name: string;
	text: string;
}

export class ThirdParty{
	card: string;
	marketplace: string;
	price?: number;
	remoteId: string;
}

export class MarketPlace{
	ref: string;
	name: string;
	logo: string;
	type: 'market' | 'provider';
	display: boolean;
	index: number;
}

export class CardCateg{
	ref: string;
	name: string;
	type: string;
}

export class CardType{
	ref: string;
	name: string;
	img: string;
	index: number;
}

export class IndexLog{
	ident: string;
	type: string;
	date: Date;
	content: string;
}